
import React from 'react';
import { SideData } from './SideData';
import SubMenu from './SubMenu';
import '../Static/PHPStatic/Sidebar.css'; // Import the CSS file

const Sidebar = ({ sidebarr }) => {
  return (
    <nav className={`sidebar-nav ${sidebarr ? 'open' : 'closed'}`}>
      <div className="sidebar-wrap">
        {SideData.map((item, index) => {
          return <SubMenu item={item} key={index} />;
        })}
      </div>
    </nav>
  );
};

export default React.memo(Sidebar);
